import { createV3Queries } from "@query/utils/createV3Queries";
import { externalBankAccountsApi } from "@api";

export const queriesExternalBankAccounts = createV3Queries(
  "externalBankAccountsApi",
  externalBankAccountsApi
);
